import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExclamationCircleIcon } from '@heroicons/react/solid';
import PropTypes from 'prop-types';
import { memo } from 'react';
import { mergeClassNames } from '../../../utils';
const CustomErrorMessage = ({ className, text, }) => (_jsxs("div", { className: mergeClassNames('flex mt-2 text-sm', className), children: [_jsx("div", { className: "w-5 h-5", children: _jsx(ExclamationCircleIcon, { className: "w-5 h-5 text-red-500", "aria-hidden": "true" }) }), _jsx("div", { className: "font-medium text-sm text-red-600", children: text })] }));
CustomErrorMessage.propTypes = {
    className: PropTypes.string,
    text: PropTypes.string,
};
export default memo(CustomErrorMessage);
